import { AppVersionOutput } from './appVersion.types';

const APP_VERSION_MANIFEST_PATH = '/version.json';

export const getPublishedAppVersion = async (): Promise<AppVersionOutput> => {
  const response = await fetch(APP_VERSION_MANIFEST_PATH, { cache: 'no-store' });

  if (!response.ok) {
    throw new Error(`failed to fetch the published app version: ${response.status}`);
  }

  return response.json();
};
